import { Injectable } from '@angular/core';

import { UUID } from 'angular2-uuid';
import AWSS3UploadAshClient from 'aws-s3-upload-ash';
import { environment } from 'environments/environment';
import { UploadResponse } from 'aws-s3-upload-ash/dist/types';

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  config = {
    bucketName: 'compra-colab',
    dirName: 'compra', /* optional - when use: e.g BUCKET_ROOT/dirName/fileName.extesion */
    region: 'us-east-1',
    accessKeyId: environment.AWS_ACCESS_KEY,
    secretAccessKey: environment.AWS_SECRET_KEY,
    s3Url: 'https://compra-colab.s3.amazonaws.com/'
  }
  S3CustomClient: AWSS3UploadAshClient = new AWSS3UploadAshClient(this.config);

  constructor() { }


  async handleSendFile(fileSelected: any) {
    console.log('ingreso a cargar la data');
    return this.S3CustomClient.uploadFile(fileSelected, fileSelected.type, undefined, fileSelected.name, "public-read");
  }
}
